"use client";

import { useState } from "react";
import { CodeBlock, type CustomRendererProps } from "streamdown";
import {
  FencedCodeCopyDownload,
  WrapCodeButton,
  useFencedCodeBlockOptions,
  wrapCodeClassName,
} from "./fenced-code-chrome";

/** A source-faithful fenced block with an opt-in readable wrapping mode. */
export function WrappableCodeBlock({ code, language, isIncomplete, meta }: CustomRendererProps) {
  const [wrap, setWrap] = useState(false);
  const label = language || "text";
  const { lineNumbers, startLine, copy, download } = useFencedCodeBlockOptions(meta);
  const wrapClass = wrapCodeClassName(wrap);

  return (
    <CodeBlock
      code={code}
      language={label}
      isIncomplete={isIncomplete}
      lineNumbers={lineNumbers}
      {...(startLine === undefined ? {} : { startLine })}
      {...(wrapClass === undefined ? {} : { className: wrapClass })}
    >
      <WrapCodeButton wrap={wrap} onClick={() => setWrap((current) => !current)} />
      <FencedCodeCopyDownload code={code} language={label} copy={copy} download={download} />
    </CodeBlock>
  );
}
